import { render, staticRenderFns } from "./imgView.vue?vue&type=template&id=0330f1c8&scoped=true&"
import script from "./imgView.vue?vue&type=script&lang=js&"
export * from "./imgView.vue?vue&type=script&lang=js&"
import style0 from "./imgView.vue?vue&type=style&index=0&id=0330f1c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0330f1c8",
  null
  
)

export default component.exports